import React, { FC, useEffect, useState } from 'react'
import Notification from 'blocks.simple/notification/notification'
import { customError, IAppNotificationsState } from './AppNotifications.state'
import translate from 'core/translate'
import { isObject } from 'core/utils/coreUtil'
import { AppErrorProps, AppError, AppCustomError } from './AppNotifications-types'
import { useTypedSelector } from 'core/store/hooks'
import { customNotification } from './AppCustomNotifications'
import { customErrorsList } from './AppCustomErrorsList'
import Toast from 'blocks.simple/toast/toast'
import Icon from '../../blocks.simple/icon/icon'
import { colors } from '../../theme'
import styles from './styles.jcss'
import Button from '../../blocks.simple/button/button'

const detailsList: { error: number | string; action: string; data: any }[] = [
    // {
    //     error: 1,
    //     action: 'redirect',
    //     data: {
    //         path: '/notificationPage'
    //     }
    // }
]

export const AppNotifications: FC<AppErrorProps> = () => {
    const { error } = useTypedSelector<IAppNotificationsState>((state) => state.appNotifications)
    const [prevError, setPrevError] = useState<any>(null)

    const showMore = (error: any) => {
        const details = detailsList.find((item) => item.error === error)

        if (details) {
            if (details.action === 'redirect') {
                window.location.hash = '/notificationPage'
            }
        }
    }

    const checkAvailableDetails = (error: any) => {
        return detailsList.some((item) => item.error === error)
    }

    const getErrorMessage = (error: AppError | AppCustomError | string | number | customError) => {
        if (!isObject(error)) {
            if (customErrorsList.includes(error.toString())) {
                return customNotification({ error })
            }
            return translate(error as string)
        }
        if ((error as AppCustomError).error) {
            if (customErrorsList.includes((error as AppCustomError).error.toString())) {
                return customNotification(error)
            }
        }

        return translate((error as AppError).errorCode, [(error as AppError).message as string])
    }

    const isNewError = error !== prevError

    useEffect(() => {
        if (error !== prevError) {
            setPrevError(error)
        }
    }, [error])

    if (
        window.location.hash.includes('/login') ||
        window.location.hash.includes('/forgetPassword') ||
        window.location.hash.includes('/authorization')
    ) {
        return (
            <Notification show={!!error}>
                <div>{error && <span>{getErrorMessage(error)}</span>}</div>
            </Notification>
        )
    }

    if (error && isNewError) {
        Toast.default(
            () => (
                <div className={styles.notification}>
                    <Icon type={'infoFill'} color={colors.white} size={20} />
                    <div className={styles.errorText}>
                        {getErrorMessage(error)}
                        {checkAvailableDetails(error) && (
                            <div className={styles.button}>
                                <Button mod={'fillWhite'} onClick={() => showMore(error)}>
                                    {translate('moreDetails')}
                                </Button>
                            </div>
                        )}
                    </div>
                </div>
            ),
            {
                autoClose: 5000,
                position: 'bottom-right',
                className: styles.toastClassName,
            }
        )
    }

    return null
}
